<template>
  <header class="header-service" :class="{ top: isSvTop() }">
    <div class="container flex">
      <div class="logo">
        <template v-if="!isAuWallet() || !isCe001()">
          <router-link class="-link" :to="{ name: 'sv001' }">
            <img
              src="@/assets/images/common/logo_main.gif"
              :alt="$t('common.sitename')"
              class="img-fluid"
              width="189"
            />
          </router-link>
        </template>
        <template v-else>
          <img
            src="@/assets/images/common/logo_main.gif"
            :alt="$t('common.sitename')"
            class="img-fluid"
            width="189"
          />
        </template>
      </div>
      <nav v-if="!isAuWallet() || !isCe001()" class="header-nav">
        <div class="subnav-list">
          <a
            href="https://qa.kddi-fs.com/?site_domain=loan"
            class="-spnone"
            target="_blank"
            ><span
              @click="
                trackGtmEvent('【click】ヘッダー', 'ヘッダー,よくあるご質問')
              "
              >よくあるご質問</span
            ></a
          >
          <router-link
            class="-spnone"
            :to="{ name: 'sv036' }"
            @click="trackGtmEvent('【click】ヘッダー', 'ヘッダー,お問い合わせ')"
            >お問い合わせ</router-link
          >
          <span class="application">
            <router-link
              :to="{ name: 'en001' }"
              @click="trackGtmEvent('【click】ヘッダー', 'ヘッダー,お申し込み')"
              >お申し込み</router-link
            >
          </span>
          <span
            class="login"
            @click.prevent="
              doLogin();
              trackGtmEvent('【click】ヘッダー', 'ヘッダー,ログイン');
            "
            >ログイン</span
          >
          <div class="-pcnone menu" @click.prevent="toggleMenu()">
            <a class="menu-trigger" :class="{ active: menuOpen }">
              <span></span>
              <span></span>
              <span></span>
            </a>
            <p class="menutxt">MENU</p>
          </div>
        </div>
        <div class="overlay" :class="{ show: menuOpen }"></div>
        <transition
          name="slide"
          @after-enter="afterEnter()"
          @before-leave="beforeLeave()"
        >
          <div
            v-show="menuOpen"
            class="-pcnone spmenu"
            :class="{ show: menuOpened }"
          >
            <AccordionList>
              <AccordionItem
                class="-heading -link"
                to="sv002"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,au PAY スマートローンの特徴'
                  )
                "
                >au PAY スマートローンの特徴</AccordionItem
              >
            </AccordionList>
            <AccordionList>
              <AccordionItem class="-heading -toggle" :toggle="true"
                >知っておきたい！ローンについて</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv003"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,知っておきたいローンについて'
                  )
                "
                >知っておきたい！ローンについて</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv043"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,知っておきたいローンについて,いまさら聞けない！ローンの基礎知識'
                  )
                "
                >いまさら聞けない！ローンの基礎知識</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv042"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,知っておきたいローンについて,教えて！みんなのローン活用術'
                  )
                "
                >教えて！みんなのローン活用術</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv044"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,知っておきたいローンについて,auサービスでもっとおトクに！'
                  )
                "
                >auサービスでもっとおトクに！</AccordionItem
              >
            </AccordionList>
            <AccordionList>
              <AccordionItem class="-heading -toggle" :toggle="true"
                >新規お申し込みについて</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv045"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,お申し込み条件・お手続きの流れ'
                  )
                "
                >お申し込み条件・お手続きの流れ</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv018"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,ご利用可能な金融機関'
                  )
                "
                >ご利用可能な金融機関</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv019"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,お申し込みに必要な書類'
                  )
                "
                >お申し込みに必要な書類</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv057"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,収入証明書について'
                  )
                "
                >収入証明書について</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv021"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,いくら借りられるの？チェック'
                  )
                "
                >いくら借りられるの？チェック</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv059"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,会員さま専用サイト・専用アプリについて'
                  )
                "
                >会員さま専用サイト・専用アプリについて</AccordionItem
              >
            </AccordionList>
            <AccordionList>
              <AccordionItem class="-heading -toggle" :toggle="true"
                >お借り入れについて</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv046"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,お借り入れについて'
                  )
                "
                >お借り入れ方法</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv024"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,お借り入れについて,au PAY 残高にチャージ'
                  )
                "
                >au PAY 残高にチャージ</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv023"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,お借り入れについて,ご登録口座へのお振込み'
                  )
                "
                >ご登録口座へのお振込み</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv025"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,お借り入れについて,セブン銀行スマホATMでお借り入れ'
                  )
                "
                >セブン銀行スマホATM</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv022"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,お借り入れについて,お利息のご案内'
                  )
                "
                >お利息のご案内</AccordionItem
              >
            </AccordionList>
            <AccordionList>
              <AccordionItem class="-heading -toggle" :toggle="true"
                >ご返済について</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv047"
                @click="
                  trackGtmEvent('【click】グロナビ', 'グロナビ,ご返済について')
                "
                >ご返済方法</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv026"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,ご返済について,ご登録口座からのお引落し'
                  )
                "
                >ご登録口座からのお引落し</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv029"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,ご返済について,セブン銀行スマホATMでご返済'
                  )
                "
                >セブン銀行スマホATM</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv027"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,ご返済について,指定口座へのお振込みによるご返済'
                  )
                "
                >指定口座へのお振込み</AccordionItem
              >
              <AccordionItem
                class="-link -inner"
                to="sv052"
                @click="
                  trackGtmEvent(
                    '【click】グロナビ',
                    'グロナビ,ご返済について,ご返済シミュレーション'
                  )
                "
                >ご返済シミュレーション</AccordionItem
              >
            </AccordionList>
            <div class="qa btn">
              <a
                href="https://qa.kddi-fs.com/?site_domain=loan"
                class="atag"
                target="_blank"
              >
                <span
                  class="txt"
                  @click="
                    trackGtmEvent(
                      '【click】ヘッダー',
                      'ヘッダー,よくあるご質問'
                    )
                  "
                  ><img
                    class="img"
                    src="@/assets/images/icons/menu-question.svg"
                    alt=""
                  />よくあるご質問</span
                >
              </a>
              <router-link
                class="atag"
                :to="{ name: 'sv036' }"
                @click="
                  trackGtmEvent('【click】ヘッダー', 'ヘッダー,お問い合わせ')
                "
              >
                <span class="txt"
                  ><img
                    class="img"
                    src="@/assets/images/icons/menu-contact.svg"
                    alt=""
                  />お問い合わせ</span
                >
              </router-link>
            </div>
            <template v-if="isWebView()">
              <div class="entry">
                <BtngroupSingle>
                  <BtnMain class="-main" href="/entry/agreement"
                    >新規お申し込み</BtnMain
                  >
                </BtngroupSingle>
              </div>
            </template>
            <template v-else>
              <div class="entry">
                <BtngroupSingle>
                  <BtnMain class="-main" router-name="en001"
                    >新規お申し込み</BtnMain
                  >
                </BtngroupSingle>
              </div>
            </template>
            <div class="close btn">
              <a class="atag" href="" @click.prevent="toggleMenu()">
                <span class="txt"
                  ><img
                    class="img"
                    src="@/assets/images/icons/close-gray.svg"
                    alt=""
                  />閉じる</span
                >
              </a>
            </div>
          </div>
        </transition>
        <NavList class="-spnone">
          <NavItem
            to="sv002"
            :class="{ active: isSvAbout() }"
            nav-name="sv-about"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,au PAY スマートローンの特徴'
              )
            "
            >au PAY スマートローンの特徴</NavItem
          >
          <NavItem :class="{ active: isSvRecipe() }" nav-name="sv-recipe"
            >知っておきたい！ローンについて</NavItem
          >
          <NavItem :class="{ active: isSvEntry() }" nav-name="sv-entry"
            >お申し込みについて</NavItem
          >
          <NavItem :class="{ active: isSvBorrow() }" nav-name="sv-borrow"
            >お借り入れについて</NavItem
          >
          <NavItem :class="{ active: isSvReturn() }" nav-name="sv-return"
            >ご返済について</NavItem
          >
        </NavList>
        <DrawerList
          to="sv003"
          nav-name="sv-recipe"
          class="-grid-2"
          src="sv-recipe.svg"
        >
          <template #title>
            <span
              @click="
                trackGtmEvent(
                  '【click】グロナビ',
                  'グロナビ,知っておきたいローンについて'
                )
              "
              >知っておきたい！ローンについて</span
            >
          </template>
          <DrawerItem
            to="sv043"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,知っておきたいローンについて,いまさら聞けない！ローンの基礎知識'
              )
            "
            >いまさら聞けない！ローンの基礎知識</DrawerItem
          >
          <DrawerItem
            to="sv042"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,知っておきたいローンについて,教えて！みんなのローン活用術'
              )
            "
            >教えて！みんなのローン活用術</DrawerItem
          >
          <DrawerItem
            to="sv044"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,知っておきたいローンについて,auサービスでもっとおトクに！'
              )
            "
            >auサービスでもっとおトクに！</DrawerItem
          >
        </DrawerList>
        <DrawerList
          to="sv045"
          nav-name="sv-entry"
          class="-grid-2"
          src="sv-entry.svg"
        >
          <template #title>
            <span>新規お申し込み<br />について</span>
          </template>
          <DrawerItem
            to="sv045"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,お申し込み条件・お手続きの流れ'
              )
            "
            >お申し込み条件・お手続きの流れ</DrawerItem
          >
          <DrawerItem
            to="sv018"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,ご利用可能な金融機関'
              )
            "
            >ご利用可能な金融機関</DrawerItem
          >
          <DrawerItem
            to="sv019"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,お申し込みに必要な書類'
              )
            "
            >お申し込みに必要な書類</DrawerItem
          >
          <DrawerItem
            to="sv057"
            @click="
              trackGtmEvent('【click】グロナビ', 'グロナビ,収入証明書について')
            "
            >収入証明書について</DrawerItem
          >
          <DrawerItem
            to="sv021"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,いくら借りられるの？チェック'
              )
            "
            >いくら借りられるの？チェック</DrawerItem
          >
          <DrawerItem
            to="sv059"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,会員さま専用サイト・専用アプリについて'
              )
            "
            >会員さま専用サイト・専用アプリについて</DrawerItem
          >
        </DrawerList>
        <DrawerList
          to="sv046"
          nav-name="sv-borrow"
          class="-grid-2"
          src="sv-borrow.svg"
        >
          <template #title>
            <span
              @click="
                trackGtmEvent(
                  '【click】グロナビ',
                  'グロナビ,お借り入れについて'
                )
              "
              >お借り入れ方法</span
            >
          </template>
          <DrawerItem
            to="sv024"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,お借り入れについて,au PAY 残高にチャージ'
              )
            "
            >au PAY 残高にチャージ</DrawerItem
          >
          <DrawerItem
            to="sv023"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,お借り入れについて,ご登録口座へのお振込み'
              )
            "
            >ご登録口座へのお振込み</DrawerItem
          >
          <DrawerItem
            to="sv025"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,ご返済について,セブン銀行スマホATMでご返済'
              )
            "
            >セブン銀行スマホATM</DrawerItem
          >
          <DrawerItem
            to="sv022"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,お借り入れについて,お利息のご案内'
              )
            "
            >お利息のご案内</DrawerItem
          >
        </DrawerList>
        <DrawerList
          to="sv047"
          nav-name="sv-return"
          class="-grid-2"
          src="sv-return.svg"
        >
          <template #title>
            <span
              @click="
                trackGtmEvent('【click】グロナビ', 'グロナビ,ご返済について')
              "
              >ご返済方法
            </span>
          </template>
          <DrawerItem
            to="sv026"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,ご返済について,ご登録口座からのお引落し'
              )
            "
            >ご登録口座からのお引落し</DrawerItem
          >
          <DrawerItem
            to="sv029"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,ご返済について,セブン銀行スマホATMでご返済'
              )
            "
            >セブン銀行スマホATM</DrawerItem
          >
          <DrawerItem
            to="sv027"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,ご返済について,指定口座へのお振込みによるご返済'
              )
            "
            >指定口座へのお振込み</DrawerItem
          >
          <DrawerItem
            to="sv052"
            @click="
              trackGtmEvent(
                '【click】グロナビ',
                'グロナビ,ご返済について,ご返済シミュレーション'
              )
            "
            >ご返済シミュレーション</DrawerItem
          >
        </DrawerList>
      </nav>
    </div>
  </header>
</template>

<script>
// import { initializCredentials } from '@/utils/Auth'
import {
  navSvAbout,
  navSvRecipe,
  navSvEntry,
  navSvBorrow,
  navSvReturn,
} from "@/router";
import { trackGtmEvent } from "@/utils/Gtm";
import NavList from "@/components/globals/NavList";
import NavItem from "@/components/globals/NavItem";
import DrawerList from "@/components/globals/DrawerList";
import DrawerItem from "@/components/globals/DrawerItem";
import AccordionList from "@/components/accordion/AccordionList";
import AccordionItem from "@/components/accordion/AccordionItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import { isWebView, isAuWallet } from "@/utils/UserAgent";

export default {
  name: "HeaderService",
  components: {
    NavList,
    NavItem,
    DrawerList,
    DrawerItem,
    AccordionList,
    AccordionItem,
    BtngroupSingle,
    BtnMain,
  },
  setup() {
    return {
      trackGtmEvent,
    };
  },
  data() {
    return {
      onMouse: "",
      menuOpen: false,
      menuOpened: false,
    };
  },
  watch: {
    $route: function () {
      this.onMouse = "";
      this.menuOpen = false;
    },
  },
  methods: {
    isSvTop: function () {
      return this.$route.name === "sv001";
    },
    isSvAbout: function () {
      return navSvAbout.indexOf(this.$route.name) !== -1;
    },
    isSvRecipe: function () {
      return navSvRecipe.indexOf(this.$route.name) !== -1;
    },
    isSvEntry: function () {
      return navSvEntry.indexOf(this.$route.name) !== -1;
    },
    isSvBorrow: function () {
      return navSvBorrow.indexOf(this.$route.name) !== -1;
    },
    isSvReturn: function () {
      return navSvReturn.indexOf(this.$route.name) !== -1;
    },
    toggleMenu: function () {
      this.menuOpen = !this.menuOpen;
    },
    afterEnter: function () {
      this.menuOpened = true;
    },
    beforeLeave: function () {
      this.menuOpened = false;
    },
    doLogin() {
      this.$router.push({ name: "ce001" });
      // initializCredentials('login').then(res => {
      //   let redirectUrl = res.redirect_url
      //   window.location.href = redirectUrl
      // }).catch(error => {
      //   console.log(error)
      //   this.$router.push({ path: '/500' })
      // })
    },
    isWebView: function () {
      return isWebView();
    },
    isAuWallet: function () {
      return isAuWallet();
    },
    isCe001: function () {
      return this.$route.name.indexOf("ce001") !== -1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.header-service {
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
  background-color: $white;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  &.top {
    .header-nav {
      .drawer-list {
        margin-top: 0px;
      }
    }
  }
  @include mq-down(md) {
    padding-top: 15px;
    padding-bottom: 10px;
  }
  @include mq-up(md) {
    padding-top: 10px;
    height: 110px;
  }
  .logo {
    width: 93px;
    @include mq-up(md) {
      display: flex;
      align-items: flex-end;
      width: 189px;
    }
  }
  .header-nav {
    > .subnav-list {
      @include mq-up(md) {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 13px;
      }
      a {
        font-size: 10px;
        padding: 7px 0 0;
        display: inline-block;
        line-height: 14px;
        text-align: center;
        @include mq-up(md) {
          font-size: 12px;
          padding: 10px 10px 0;
          line-height: 16px;
          min-width: 80px;
          min-height: 36px;
        }
      }
      > .application,
      .logout {
        @include mq-down(md) {
          float: left;
          margin-top: 2px;
          a {
            min-width: 65px;
            min-height: 29px;
          }
        }
        a {
          color: $white;
        }
      }
      > .application {
        background-color: $primary;
        border-radius: 6px;
        margin-right: 2px;
        @include mq-up(md) {
          margin-left: 10px;
        }
      }
      > .login {
        background-color: $white;
        border: 1px solid $secondary;
        border-radius: 6px;
        font-size: 10px;
        padding: 7px 0 0;
        display: inline-block;
        line-height: 14px;
        color: $primary;
        cursor: pointer;
        min-width: 65px;
        min-height: 29px;
        text-align: center;
        @include mq-up(md) {
          font-size: 12px;
          padding: 10px 0 0;
          line-height: 16px;
          min-width: 80px;
          min-height: 36px;
        }
        @include mq-down(md) {
          float: left;
          margin-top: 2px;
        }
      }
      > .logout {
        border: 1px solid $secondary;
        border-radius: 6px;
        > a {
          color: $primary;
        }
      }
      > .menu {
        float: left;
        width: 30px;
        margin-left: 20px;
        > .menutxt {
          font-size: 10px;
          margin-bottom: 0;
          line-height: 18px;
        }
        > .menu-trigger,
        > .menu-trigger span {
          display: inline-block;
          transition: all 0.4s;
          box-sizing: border-box;
        }
        > .menu-trigger {
          position: relative;
          width: 24px;
          height: 18px;
          margin-left: 3px;
          > span {
            position: absolute;
            left: 0;
            width: 100%;
            height: 2px;
            background-color: $gray;
            border-radius: 4px;
          }
        }
        .top & {
          > .menutxt {
            color: $white;
          }
        }
        > .menu-trigger span:nth-of-type(1) {
          top: 0;
        }
        > .menu-trigger span:nth-of-type(2) {
          top: 8px;
        }
        > .menu-trigger span:nth-of-type(3) {
          bottom: 0;
        }
        > .menu-trigger.active span:nth-of-type(1) {
          -webkit-transform: translateY(8px) rotate(-45deg);
          transform: translateY(8px) rotate(-45deg);
        }
        > .menu-trigger.active span:nth-of-type(2) {
          opacity: 0;
        }
        > .menu-trigger.active span:nth-of-type(3) {
          -webkit-transform: translateY(-8px) rotate(45deg);
          transform: translateY(-8px) rotate(45deg);
        }
      }
    }
    > .spmenu {
      &.slide-enter,
      &.slide-leave-to {
        left: 100%;
      }
      &.slide-enter-to,
      &.slide-leave {
        left: 20%;
      }
      &.slide-enter-active,
      &.slide-leave-active {
        transition: left 0.3s ease;
      }
      position: fixed;
      top: 65px;
      z-index: 9998;
      width: 80%;
      height: calc(100% - 65px);
      overflow-y: auto;
      &.show {
        left: 20%;
      }
      > .entry {
        padding: 15px;
        background-color: $success;
      }
      > .btn {
        width: 100%;
        height: 56px;
        display: flex;
        background-color: $white;
        > .atag {
          display: flex;
          height: 100%;
          line-height: 100%;
          justify-content: center;
          align-items: center;
          > .txt {
            > .img {
              width: 20px;
              height: auto;
              margin-right: 5px;
              vertical-align: middle;
            }
          }
        }
        &.qa {
          border-bottom: 1px solid $secondary;
          > .atag {
            width: 50%;
            font-size: 12px;
            &:nth-last-of-type(1) {
              border-left: 1px solid $secondary;
            }
          }
        }
        &.close {
          > .atag {
            width: 100%;
            > .txt {
              > .img {
                width: 15px;
                margin-right: 10px;
                vertical-align: top;
              }
            }
          }
        }
      }
    }
    .overlay {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 65px;
      left: 0;
      z-index: 9997;
      background-color: rgba($black, 0.4);
      transition: all 300ms ease;
      opacity: 0;
      visibility: hidden;
      &.show {
        opacity: 1;
        visibility: visible;
      }
    }
  }
}
</style>
